const baseURL = 'https://tienda.celularserviciotecnico.com.ar/';

export default baseURL;
